export default __webpack_public_path__ + "static/media/wait_page.55e34431.svg";